module.exports = "/_next/static/images/marta-286112f8f0d25017509e857f52313b2a.png";